export { TabsComponent as Tabs } from './Tabs.js';
export type { TabsPropTypes } from './Tabs.types.js';
